<template>
  <table class="table text-center table-bordered table-sm text-dark mb-1">
    <thead>
    <tr class="text-center">
      <th class="lead bg-ffd966">Description</th>
      <th v-for=" (year,index) in years " :class="{
        'lead bg-bfbfbf' : index ===0,
        'lead bg-a6a6a6' : index ===1,
        'lead bg-ffd966' : index ===2,
        'lead bg-f7caac' : index ===3,
        'lead bg-f4b083' : index ===4,
        'lead bg-ff0000' : index ===5,
      }"> {{year}}</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(item, index) in data" :class="{'hr-line' : index === data.length - 1}">
      <td :class="{'hr-line' : index === data.length - 1}">{{item.event}}</td>
      <td :class="{'hr-line' : index === data.length - 1}" v-for="(year) in years">
        {{item.years[year]}}
      </td>
    </tr>
    <tr>
      <td><h6 class="font-weight-bold text-danger m-0 p-0">SUMMARY</h6></td>
      <template v-for="(year) in years">
        <td><h6 class="font-weight-bold text-danger m-0 p-0">{{ yearlySummary[year]}}</h6></td>
      </template>
    </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "RightshipYearlyTable",
  props:{
    data:{
      type:Object | Array,
      default:null
    },
    years:{
      type:Object | Array,
      default: null
    },
  },
  computed : {
    yearlySummary() {
      const totals = {};
      this.data.forEach(item => {
        Object.entries(item.years).forEach(([year, value]) => {
          totals[year] = ((totals[year] || 0) + parseFloat(value));
        });
      });

      Object.keys(totals).forEach(year => {
        totals[year] = parseFloat(totals[year].toFixed(2));
      });

      return totals;
    }
  }
}
</script>

<style scoped>
.tr.hr-line , td.hr-line{
  border-bottom: 2px solid black;
}
</style>
